import React, { useEffect, useRef } from "react";
import "../../stylesheet/components/media/MediaBody.scss";
import ShareButtons from "../singlecomponents/ShareButtons";
import YellowDivider from "../../components/dividers/YellowDivider";
import ArticleInfo from "../../components/article/ArticleInfo";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Button from "../singlecomponents/Button";
import { Media } from "../../compilers/media";
import "../../stylesheet/components/media/MediaBody.scss";

type ArticleBodyProps = {
  media: Media;
};

const ArticleBody: React.FC<ArticleBodyProps> = ({ media }) => {
  const mediaArticle = useRef<HTMLDivElement>(null);
  const history = useHistory();
  const { t } = useTranslation();

  const goToPreviousPath = () => {
    history.goBack();
  };

  const getHeroImage = () => {
    if (media.data.heroImage) {
      return (
        <img
          src={media.data.heroImage}
          className="media-hero-image mb-lg-0 mb-xl-3"
          alt=""
        />
      );
    }
  };

  useEffect(() => {
    // This EFFECT is targeting the media article for creating specific logic
    if (mediaArticle?.current) {
      // 1. TABLE
      const mediaTables = Array.from(
        mediaArticle.current?.getElementsByTagName("table")
      );
      mediaTables.forEach(
        (tag) =>
          (tag.outerHTML = `<div class="table-wrapper">${tag.outerHTML}</div>`)
      );
      // 2. ANCHOR LINK
      const allLinks = Array.from(mediaArticle.current?.getElementsByTagName("a"));
      allLinks.forEach(link => {
        link.setAttribute("target", "_blank"); 
        if(!link.getAttribute("href").includes("http")){
          link.setAttribute("href", `http://${link.getAttribute("href")}`)
        }
      });
      // 3. ORDERED LIST
      const AllOrderedList = Array.from((mediaArticle.current?.getElementsByTagName("ol")))
      AllOrderedList.forEach(list => {
        const AllList = Array.from(list.children);
        AllList.forEach(li => {
          const LiContent = Array.from(li.children);
          LiContent.forEach(content => {            
            if(content.getElementsByTagName("strong").length > 0 || content.tagName == "STRONG"){
              li.classList.add("bold");
            }
          })
        })
      })
    }

  });

  const getInnerHTML = () => {
    if (typeof media.data.body === "string") {
      return media.data.body;
    }
  };

  return (
    <div className="media-body">
      {getHeroImage()}
      <div className="hidden-desktop py-3">
        <h1 className="h2">{media.data.title}</h1>
        <YellowDivider heading="h1" />
      </div>
      <ArticleInfo className="hidden-desktop mb-3" media={media} />
      <div
        ref={mediaArticle}
        className="media-article px-lg-4"
        dangerouslySetInnerHTML={{ __html: getInnerHTML() }}
      />
      <div className="media-back-and-share">
        <div className="back-btn" onClick={goToPreviousPath}>
          <Button
            bootstrapClass="px-sm-2 px-md-4 py-1"
            name={t("button.back")}
          />
        </div>
        <ShareButtons />
      </div>
    </div>
  );
};

export default ArticleBody;
